<mat-card-header>
  <mat-card-title><ng-content /></mat-card-title>
  <svg-icon icon="icon_cancel" matTooltip="Close modal" i18n-matTooltip="@@Common.button.close" (click)="close()" />
</mat-card-header>
